<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="3">
        <loading-field v-if="loadingChartDelaiDeclarationHorsBpij"></loading-field>
        <line-charts chartId="delaiDeclarationHB" v-if="!isEmpty(dataDelaiDeclarationHorsBpij) && !loadingChartDelaiDeclarationHorsBpij" :datas="dataDelaiDeclarationHorsBpij" style="height:200px;" :height="200"></line-charts>
      </b-col>
      <b-col md="3">
        <loading-field v-if="loadingChartDelaiTraitementHorsBpij"></loading-field>
        <line-charts chartId="delaiTraitementHB" v-if="!isEmpty(dataDelaiTraitementHorsBpij) && !loadingChartDelaiTraitementHorsBpij" :datas="dataDelaiTraitementHorsBpij" style="height:200px;" :height="200"></line-charts>
      </b-col>
      <b-col md="3">
        <loading-field v-if="loadingChartDelaiDeclarationBpij"></loading-field>
        <line-charts chartId="delaiDeclarationB" v-if="!isEmpty(dataDelaiDeclarationBpij) && !loadingChartDelaiDeclarationBpij" :datas="dataDelaiDeclarationBpij" style="height:200px;" :height="200"></line-charts>
      </b-col>
      <b-col md="3">
        <loading-field v-if="loadingChartDelaiTraitementBpij"></loading-field>
        <line-charts chartId="delaiTraitementB" v-if="!isEmpty(dataDelaiTraitementBpij) && !loadingChartDelaiTraitementBpij" :datas="dataDelaiTraitementBpij" style="height:200px;" :height="200"></line-charts>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="3">
        <loading-field v-if="loadingChartNbDossierDeclarationHorsBpij"></loading-field>
        <bar-charts chartId="nbDossierDeclarationHB" v-if="!isEmpty(dataNbDossierDeclarationHorsBpij) && !loadingChartNbDossierDeclarationHorsBpij" :datas="dataNbDossierDeclarationHorsBpij" style="height:200px;" :height="200"></bar-charts>
      </b-col>
      <b-col md="3">
        <loading-field v-if="loadingChartNbDossierTraitementHorsBpij"></loading-field>
        <bar-charts chartId="nbDossierTraitementHB" v-if="!isEmpty(dataNbDossierTraitementHorsBpij) && !loadingChartNbDossierTraitementHorsBpij" :datas="dataNbDossierTraitementHorsBpij" style="height:200px;" :height="200"></bar-charts>
      </b-col>
      <b-col md="3">
        <loading-field v-if="loadingChartNbDossierDeclarationBpij"></loading-field>
        <bar-charts chartId="nbDossierDeclarationB" v-if="!isEmpty(dataNbDossierDeclarationBpij) && !loadingChartNbDossierDeclarationBpij" :datas="dataNbDossierDeclarationBpij" style="height:200px;" :height="200"></bar-charts>
      </b-col>
      <b-col md="3">
        <loading-field v-if="loadingChartNbDossierTraitementBpij"></loading-field>
        <bar-charts chartId="nbDossierTraitementB" v-if="!isEmpty(dataNbDossierTraitementBpij) && !loadingChartNbDossierTraitementBpij" :datas="dataNbDossierTraitementBpij" style="height:200px;" :height="200"></bar-charts>
      </b-col>
    </b-row>

    <b-modal size="xl" scrollable id="modal-detail-stat" ref="modal-detail-stat" title="Détail des stats pour le mois sélectionné">
      <b-row>
        <b-col sm=12>
          <line-charts chartId="detailChart" v-if="!isEmpty(dataDetail)" :datas="dataDetail" style="height:300px;" :height="300"></line-charts>
        </b-col>
      </b-row>
      <template v-slot:modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-secondary mr-1" @click="$bvModal.hide('modal-detail-stat')">Fermer</button>
        </div>
      </template>

    </b-modal>
  </div>
</template>

<script>
  import {isEmpty} from "@/utils/fileHelper";

  import LoadingField from '@/components/LoadingField';
  import LineCharts from '@/components/Charts/LineCharts';
  import BarCharts from '@/components/Charts/BarCharts';

  export default {
    components: {
      LineCharts,
      BarCharts,
      LoadingField
    },
    props: [
      'siren'
    ],
    data() {
      return {
        isEmpty,
        dataDelaiDeclarationHorsBpij: {},
        dataDelaiDeclarationBpij: {},
        dataDelaiTraitementHorsBpij: {},
        dataDelaiTraitementBpij: {},
        dataNbDossierDeclarationHorsBpij: {},
        dataNbDossierDeclarationBpij: {},
        dataNbDossierTraitementHorsBpij: {},
        dataNbDossierTraitementBpij: {},
        dataDetail: {},
        loadingChartDelaiDeclarationHorsBpij: true,
        loadingChartDelaiTraitementHorsBpij: true,
        loadingChartDelaiDeclarationBpij: true,
        loadingChartDelaiTraitementBpij: true,
        loadingChartNbDossierTraitementHorsBpij: true,
        loadingChartNbDossierDeclarationHorsBpij: true,
        loadingChartNbDossierDeclarationBpij: true,
        loadingChartNbDossierTraitementBpij: true,
      }
    },
    mounted() {
      this.$event.on('getStatsDetail',(data) => {
        let chart = data.value[0];
        let labels = data.labels;
        let type = data.type;
        let bpij = data.bpij;
        let date = labels[chart['_index']];

        this.getSirenStatsDetail(date, type, bpij);
      })
    },
    created() {
      // récupération des stats
      this.getSirenStats('delaiDeclaration', 'horsBpij');
      this.getSirenStats('nbDossierDeclaration', 'horsBpij');
      this.getSirenStats('delaiDeclaration', 'bpij');
      this.getSirenStats('nbDossierDeclaration', 'bpij');
      this.getSirenStats('delaiTraitement', 'horsBpij');
      this.getSirenStats('nbDossierTraitement', 'horsBpij');
      this.getSirenStats('delaiTraitement', 'bpij');
      this.getSirenStats('nbDossierTraitement', 'bpij');
    },
    methods: {
      getSirenStats(type, bpij) {
        let dataPost = {
          siren: this.siren,
          type: type,
          bpij: bpij,
        }
        this.loadingChart = true;
        this.$axios
          .post("/espaceGestion/siren/getSirenStats", dataPost)
          .then(response => {
            if (type === 'delaiDeclaration') {
              if (bpij === 'horsBpij') {
                this.dataDelaiDeclarationHorsBpij = {
                  type: 'declaration',
                  bpij: bpij,
                  labels: response.data.stats.statsSiren.labels,
                  datas: [
                    {
                      label: 'Délai moyen de déclaration (hors BPIJ)',
                      backgroundColor: response.data.stats.statsSiren.backgroundColor,
                      data: response.data.stats.statsSiren.stats
                    },
                  ]
                };
                this.loadingChartDelaiDeclarationHorsBpij = false;
              } else {
                this.dataDelaiDeclarationBpij = {
                  type: 'declaration',
                  bpij: bpij,
                  labels: response.data.stats.statsSiren.labels,
                  datas: [
                    {
                      label: 'Délai moyen de déclaration (BPIJ)',
                      backgroundColor: response.data.stats.statsSiren.backgroundColor,
                      data: response.data.stats.statsSiren.stats
                    },
                  ]
                };
                this.loadingChartDelaiDeclarationBpij = false;
              }
              
            }

            if (type === 'delaiTraitement') {
              if (bpij === 'horsBpij') {
                this.dataDelaiTraitementHorsBpij = {
                  type: 'traitement',
                  bpij: bpij,
                  labels: response.data.stats.statsSiren.labels,
                  datas: [
                    {
                      label: 'Délai moyen de traitement (hors BPIJ)',
                      backgroundColor: response.data.stats.statsSiren.backgroundColor,
                      data: response.data.stats.statsSiren.stats
                    },
                  ]
                };
                this.loadingChartDelaiTraitementHorsBpij = false;
              } else {
                this.dataDelaiTraitementBpij = {
                  type: 'traitement',
                  bpij: bpij,
                  labels: response.data.stats.statsSiren.labels,
                  datas: [
                    {
                      label: 'Délai moyen de traitement (BPIJ)',
                      backgroundColor: response.data.stats.statsSiren.backgroundColor,
                      data: response.data.stats.statsSiren.stats
                    },
                  ]
                };
                this.loadingChartDelaiTraitementBpij = false;
              }
            }

            if (type === 'nbDossierDeclaration') {
              if (bpij === 'horsBpij') {
                this.dataNbDossierDeclarationHorsBpij = {
                  type: 'nbDossierDeclaration',
                  bpij: bpij,
                  labels: response.data.stats.statsSiren.labels,
                  datas: [
                    {
                      label: 'Nombre de dossier déclarés (hors BPIJ)',
                      backgroundColor: response.data.stats.statsSiren.backgroundColor,
                      data: response.data.stats.statsSiren.stats
                    },
                  ]
                };
                this.loadingChartNbDossierDeclarationHorsBpij = false;
              } else {
                this.dataNbDossierDeclarationBpij = {
                  type: 'nbDossierDeclaration',
                  bpij: bpij,
                  labels: response.data.stats.statsSiren.labels,
                  datas: [
                    {
                      label: 'Nombre de dossier déclaré (BPIJ)',
                      backgroundColor: response.data.stats.statsSiren.backgroundColor,
                      data: response.data.stats.statsSiren.stats
                    },
                  ]
                };
                this.loadingChartNbDossierDeclarationBpij = false;
              }
            }

            if (type === 'nbDossierTraitement') {
              if (bpij === 'horsBpij') {
                this.dataNbDossierTraitementHorsBpij = {
                  type: 'nbDossierTraitement',
                  bpij: bpij,
                  labels: response.data.stats.statsSiren.labels,
                  datas: [
                    {
                      label: 'Nombre de dossier Traité (hors BPIJ)',
                      backgroundColor: response.data.stats.statsSiren.backgroundColor,
                      data: response.data.stats.statsSiren.stats
                    },
                  ]
                };
                this.loadingChartNbDossierTraitementHorsBpij = false;
              } else {
                this.dataNbDossierTraitementBpij = {
                  type: 'nbDossierTraitement',
                  bpij: bpij,
                  labels: response.data.stats.statsSiren.labels,
                  datas: [
                    {
                      label: 'Nb Traité (BPIJ)',
                      backgroundColor: response.data.stats.statsSiren.backgroundColor,
                      data: response.data.stats.statsSiren.stats
                    },
                    {
                      label: 'Nb Traité AutoBpij (BPIJ)',
                      backgroundColor: response.data.stats.statsSiren.backgroundColor2,
                      data: response.data.stats.statsSiren.stats2
                    },
                  ]
                };
                this.loadingChartNbDossierTraitementBpij = false;
              }
            }
          })
          .catch((error) => {
            console.log(error)
            this.loadingChartDelaiDeclarationHorsBpij = false;
            this.loadingChartDelaiDeclarationBpij = false;
            this.loadingChartDelaiTraitementHorsBpij = false;
            this.loadingChartDelaiTraitementBpij = false;
            this.loadingChartNbDossierTraitementHorsBpij = false;
            this.loadingChartNbDossierDeclarationHorsBpij = false;
            this.loadingChartNbDossierDeclarationBpij = false;
            this.loadingChartNbDossierTraitementBpij = false;
          });
      },
      getSirenStatsDetail(date, type, bpij) {
        let dataPost = {
          siren: this.siren,
          date: date,
          type: type,
          bpij: bpij,
        }
        this.$store.commit("IS_LOADING", true);
        this.$axios
          .post("/espaceGestion/siren/getSirenStatsDetail", dataPost)
          .then(response => {
            this.dataDetail = {
              type: response.data.stats.statsDelai.type,
              labels: response.data.stats.statsDelai.labels,
              datas: [
                {
                  label: 'Délai moyen de déclaration',
                  backgroundColor: response.data.stats.statsDelai.backgroundColor,
                  data: response.data.stats.statsDelai.stats
                },
              ]
            };
            this.$store.commit("IS_LOADING", false);
            this.$refs['modal-detail-stat'].show();
          })
          .catch((error) => {
            console.log(error)
            this.$store.commit("IS_LOADING", false);
          });
      },
    }
  }
</script>

